import React from 'react';
import PropTypes from 'prop-types';
import SelectField from './SelectField/SelectField';
import { productAttributeFields } from 'helpers/product';

const ProductAttributeInput = (props) => {
    const { choices } = props;

    return (
        <SelectField
            { ...props }
            choices={ choices }
        />
    );
};

ProductAttributeInput.defaultProps = {
    choices: Object.keys(productAttributeFields).map((productAttributeField) => {
        return {
            id: productAttributeField,
            name: `resources.products.fields.${ productAttributeField }`,
        };
    }),
};

ProductAttributeInput.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    })),
    input: PropTypes.shape({
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    label: PropTypes.string,
    meta: PropTypes.object,
};

export default ProductAttributeInput;



// WEBPACK FOOTER //
// ./src/components/input/ProductAttributeInput.js